import React, { useContext, useState } from 'react';
import Cookies from 'js-cookie';
import { Link } from 'react-router-dom';
import UserContext from '../user/UserContext';
import { FormControl, Modal } from 'react-bootstrap';
import TelesalesSelector from './TelesalesSelector';
import DeliveryInformation from './DeliveryInformation';
import { useHistory } from 'react-router-dom';

export default function Header() {
    const [showTelesalesSelector, setShowTelesalesSelector] = useState(true);

    const { userDetails, updateCurrentFranchise } = useContext(UserContext);

    const history = useHistory();

    function logout() {
        Cookies.remove('CASTGC', { domain: 'costcutter.com', path: '/' });
        sessionStorage.removeItem('accessToken');
        let redirect = '?service=' + encodeURIComponent(window.location.origin);
        window.location.href = window.CONFIG['ws.cas.logout'] + redirect;
    }

    return (
        <div>
            <header className={'site-header flex'}>
                <div className={'content header-container flex'}>
                    <div className={'logo-wrapper flex'}>
                        <Link to={'/'} title={'ActivOC'}>
                            <img className={'logo'} src={'/logos/activOC.png'} alt={'ActivOC'} />
                        </Link>
                    </div>
                    <div className={'store-selector flex'}>
                        <>
                            {userDetails.currentFranchise && !userDetails.telesales && (
                                <>
                                    <span className={'selector-label'}>Viewing store:</span>
                                    <FormControl
                                        as={'select'}
                                        className={'selected-store'}
                                        value={userDetails.currentFranchise.code}
                                        onChange={e => {
                                            updateCurrentFranchise(
                                                userDetails.allFranchises.filter(
                                                    franchise => franchise.code === e.target.value
                                                )[0]
                                            );
                                            history.push('/');
                                        }}
                                    >
                                        {userDetails.allFranchises.map(franchise => (
                                            <option value={franchise.code} key={franchise.code}>
                                                {franchise.code +
                                                    ' ' +
                                                    franchise.name +
                                                    (franchise.onHold ? ' (on hold)' : '')}
                                            </option>
                                        ))}
                                    </FormControl>
                                </>
                            )}
                        </>
                        <>
                            {userDetails.telesales && (
                                <>
                                    <div
                                        className={'telesales-selected-store'}
                                        onClick={() => setShowTelesalesSelector(!showTelesalesSelector)}
                                    >
                                        {userDetails.currentFranchise
                                            ? userDetails.currentFranchise.code +
                                              ' ' +
                                              userDetails.currentFranchise.name +
                                              (userDetails.currentFranchise.onHold ? ' (on hold)' : '')
                                            : 'TELESALES'}
                                    </div>
                                    <Modal
                                        show={showTelesalesSelector}
                                        size="lg"
                                        className={'telesales-modal'}
                                        onHide={() => {
                                            userDetails.currentFranchise
                                                ? setShowTelesalesSelector(false)
                                                : logout();
                                        }}
                                    >
                                        <TelesalesSelector
                                            close={() => {
                                                setShowTelesalesSelector(false);
                                            }}
                                            logout={logout}
                                        />
                                    </Modal>
                                </>
                            )}
                        </>
                    </div>
                    <div className={'header-delivery-info'}>
                        <DeliveryInformation />
                    </div>
                    <ul className={'header-links flex'}>
                        <li className={'logout-container'}>
                            <a
                                href={'/'}
                                onClick={e => {
                                    logout();
                                    e.preventDefault();
                                }}
                                id={'logoutLink'}
                            >
                                Log out
                            </a>
                        </li>
                    </ul>
                </div>
            </header>
        </div>
    );
}
